import { useEffect, useState } from 'react';

/**
 * True for phone-sized layouts. Uses CSS media + screen width fallback
 * (Safari "Request Desktop Website" keeps a wide layout viewport).
 */
export default function useIsPhoneLayout(breakpointPx = 768) {
  const [isPhone, setIsPhone] = useState(() => {
    if (typeof window === 'undefined') return false;
    return computeIsPhone(breakpointPx);
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const update = () => setIsPhone(computeIsPhone(breakpointPx));
    update();
    const mq = window.matchMedia(`(max-width: ${breakpointPx}px)`);
    const coarse = window.matchMedia('(pointer: coarse)');
    mq.addEventListener?.('change', update);
    coarse.addEventListener?.('change', update);
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      mq.removeEventListener?.('change', update);
      coarse.removeEventListener?.('change', update);
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, [breakpointPx]);

  return isPhone;
}

function computeIsPhone(breakpointPx) {
  try {
    const mqNarrow = window.matchMedia(`(max-width: ${breakpointPx}px)`).matches;
    if (mqNarrow) return true;
    // iPhone / Android with desktop-site mode: layout viewport is wide, screen is not
    const screenW = Math.min(window.screen?.width || 9999, window.screen?.height || 9999);
    const coarse = window.matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0;
    if (coarse && screenW > 0 && screenW <= 500) return true;
    return false;
  } catch (_) {
    return false;
  }
}
